import React, { useState, useEffect } from 'react';
import Loading from '../../Common/Loading';

// --- Assets ---
import goImgN from '../../Images/go_n.gif';
import goImgO from '../../Images/go_o.gif';
import closeImgN from '../../Images/close_n.gif';
import closeImgO from '../../Images/close_o.gif';
import saveImgN from '../../Images/save_n.gif';
import saveImgO from '../../Images/save_o.gif';
import { useNavigate } from "react-router-dom";
import popimg from "../../Common/Images/ImagesForAlert/popup_bg1.png";
import popbg from "../../Common/Images/ImagesForAlert/popup_bg2.png";
import popclose from "../../Common/Images/ImagesForAlert/popup_close_n.png";

interface LPMessage {
    UniqueID: number;
    Country: string;
    ActivityTypeDisplay: string;
    HowAddedDisplay: string;
    ScoreCheck: string;
    CurrentLogicUsedDisplay: string;
    NextLogicToBeUsedDisplay: string;
    StudentComment: string;
    ParentComment: string;
}

const EL_LessonPlanMessages: React.FC = () => {

    const API_BASE =
        process.env.REACT_APP_DOCUMENT_LINK;

    // State
    const [countries, setCountries] = useState<string[]>([]);
    const [selectedCountry, setSelectedCountry] = useState<string>('-Select-');

    const [messages, setMessages] = useState<LPMessage[]>([]);
    const [selectedRow, setSelectedRow] = useState<LPMessage | null>(null);

    // Form State
    const [studentComment, setStudentComment] = useState<string>('');
    const [parentComment, setParentComment] = useState<string>('');

    const [loading, setLoading] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>('');

    // Hover states for image buttons
    const [goHover, setGoHover] = useState(false);
    const [closeHover, setCloseHover] = useState(false);
    const [saveHover, setSaveHover] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        document.body.style.margin = '0px';
        document.body.style.fontFamily = 'Arial, sans-serif';
        document.body.style.backgroundColor = "#fff";
        fetchCountries();
    }, []);

    const fetchCountries = async () => {
        setLoading(true);

        try {
            const res = await fetch(`${API_BASE}api/lpmessages/countries`);

            if (!res.ok) {
                throw new Error(`Failed to fetch countries: ${res.status}`);
            }

            const json = await res.json();

            if (json.countries) {
                setCountries(json.countries);
            }
        } catch (err) {
            console.error("Error fetching countries", err);
            setErrorMsg("Failed to load countries.");
        } finally {
            setLoading(false);
        }
    };

    const handleGo = async () => {
        if (selectedCountry === '-Select-') {
            alert("Please select a Country before proceeding.");
            return;
        }

        setLoading(true);
        setErrorMsg('');
        setSelectedRow(null); // Hide bottom div
        setStudentComment('');
        setParentComment('');

        try {
            const res = await fetch(`${API_BASE}api/wlpmessages/list?country=${selectedCountry}`);
            const json = await res.json();
            if (json.error) throw new Error(json.error);
            setMessages(json.messages || []);
        } catch (err) {
            setErrorMsg("Failed to load messages.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        document.body.style.backgroundColor = 'azure'
    })

    const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedCountry(e.target.value);
        // Clear inputs on change just like fn_DDlChange
        setStudentComment('');
        setParentComment('');
        setSelectedRow(null);
    };

    const handleRowSelect = (row: LPMessage) => {
        setSelectedRow(row);
        setStudentComment(row.StudentComment || '');
        setParentComment(row.ParentComment || '');
    };

    const handleSave = async () => {
        if (!selectedRow) {
            alert("Please select a row before proceeding.");
            return;
        }
        if (selectedRow.Country !== selectedCountry) {
            alert("Please Click Go as there is mismatch in the selected Country");
            return;
        }
        if (!studentComment.trim()) {
            alert("Student Comment Cannot be empty.");
            return;
        }
        if (!parentComment.trim()) {
            alert("Parent Comment Cannot be empty.");
            return;
        }

        setLoading(true);
        try {
            const res = await fetch(`${API_BASE}api/lpmessages/save`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    unique_id: selectedRow.UniqueID,
                    student_comment: studentComment,
                    parent_comment: parentComment
                })
            });
            const json = await res.json();

            if (json.error) {
                alert(json.error);
            } else {
                setStudentComment('');
                setParentComment('');
                handleGo(); // Refresh the table automatically
            }
        } catch (err) {
            alert("Error saving messages.");
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        navigate("/SysAdmin");
    };
    const styles = {
        header: {
            border: '1px solid black', padding: '10px', textAlign: 'center' as const,
            fontFamily: 'Arial', fontSize: 'medium', backgroundColor: '#DFF8FF', color: '#000099'
        },
        gridContainer: { padding: '5px' },
        gridWrapper: { overflowY: 'auto' as const, overflowX: 'auto' as const, maxHeight: '600px', border: '1px solid #a3c0e8' },
        gridTable: { width: '100%', minWidth: '1200px', borderCollapse: 'collapse' as const, fontSize: '12px', border: '1px solid #a3c0e8' },
        gridTh: { backgroundColor: '#c7ddfd', fontSize: "11pt", color: '#2859ac', border: '1px solid #a3c0e8', padding: '10px', textAlign: 'left' as const, fontWeight: 'normal', position: 'sticky' as const, top: 0 },
        gridTd: { padding: '8px', borderLeft: '1px solid #a3c0e8', borderRight: '1px solid #a3c0e8', cursor: 'pointer', fontSize: "10pt" },

        selectedRow: { backgroundColor: 'orange', color: 'white' },
        altRow: { backgroundColor: '#f4faff' },
        defaultRow: { backgroundColor: 'white' },

        bottomDiv: { padding: '10px', textAlign: 'center' as const, fontFamily: 'Arial' },
        bottomTable: { width: '100%', borderCollapse: 'collapse' as const },
        bottomLabel: { color: '#000099', fontWeight: 'bold' },
        bottomInput: {
            width: '99%', color: 'Blue', fontWeight: 'bold', border: 'solid 1px #003300',
            fontFamily: 'Arial', fontSize: '12pt', padding: '2px'
        }
    };

    return (
        <div>
            {loading && <Loading />}

            <div
                style={{
                    backgroundImage: `url(${popimg}), url(${popbg})`,
                    backgroundRepeat: "no-repeat, no-repeat",
                    backgroundPosition: "left center, right center",
                    backgroundSize: "30% 100%, 70% 100%",
                    height: "16px",
                    color: "white",
                    padding: "7px 0px",
                    fontWeight: "bold",
                    fontSize: "12pt",
                    fontFamily: "arial",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <span style={{ marginLeft: "10px" }}>Lesson Plan Messages</span>
                <img
                    src={popclose}
                    alt="close"
                    height="30px"
                    style={{ cursor: "pointer" }}
                    onClick={handleClose}
                />
            </div>
            {/* Header Banner */}
            <div style={styles.header}>
                <b>WEEKLY LESSON PLAN MESSAGES</b>
                &nbsp;&nbsp;&nbsp;
                Select Country: &nbsp;
                <select style={{ width: '15%' }} value={selectedCountry} onChange={handleCountryChange}>
                    <option value="-Select-">-Select-</option>
                    {countries.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
                &nbsp;&nbsp;&nbsp;
                <img
                    src={goHover ? goImgO : goImgN}
                    alt="GO"
                    onMouseEnter={() => setGoHover(true)}
                    onMouseLeave={() => setGoHover(false)}
                    onClick={handleGo}
                    style={{ verticalAlign: 'middle', cursor: 'pointer' }}
                />
                &nbsp;&nbsp;&nbsp;
                <img
                    src={closeHover ? closeImgO : closeImgN}
                    alt="Close"
                    onMouseEnter={() => setCloseHover(true)}
                    onMouseLeave={() => setCloseHover(false)}
                    onClick={handleClose}
                    style={{ verticalAlign: 'middle', cursor: 'pointer' }}
                />
            </div>

            {errorMsg && <div style={{ color: 'red', fontWeight: 'bold', padding: '10px', textAlign: 'center' }}>{errorMsg}</div>}

            {/* Data Grid */}
            <div style={styles.gridContainer}>
                {messages.length > 0 && (
                    <div style={styles.gridWrapper}>
                        <table style={styles.gridTable}>
                            <thead>
                                <tr>
                                    {/* Adjusted widths to give maximum space to the comment fields */}
                                    <th style={{ ...styles.gridTh, width: '2%', textAlign: 'center' }}>#</th>
                                    <th style={{ ...styles.gridTh, width: '8%' }}>Activity Type</th>
                                    <th style={{ ...styles.gridTh, width: '10%' }}>How Added</th>
                                    <th style={{ ...styles.gridTh, width: '5%' }}>Score</th>
                                    <th style={{ ...styles.gridTh, width: '15%' }}>Current Logic Used</th>
                                    <th style={{ ...styles.gridTh, width: '10%' }}>Next Logic ToBeUsed</th>
                                    <th style={{ ...styles.gridTh, width: 'auto', whiteSpace: 'nowrap' as const }}>Student Comment</th>
                                    <th style={{ ...styles.gridTh, width: 'auto', whiteSpace: 'nowrap' as const }}>Parent Comment</th>
                                </tr>
                            </thead>
                            <tbody>
                                {messages.map((row, idx) => {
                                    const isSelected = selectedRow?.UniqueID === row.UniqueID;
                                    return (
                                        <tr
                                            key={row.UniqueID}
                                            onClick={() => handleRowSelect(row)}
                                            style={isSelected ? styles.selectedRow : (idx % 2 === 0 ? styles.defaultRow : styles.altRow)}
                                        >
                                            <td style={{ ...styles.gridTd, textAlign: 'center' }}>{idx + 1}</td>
                                            <td style={styles.gridTd}>{row.ActivityTypeDisplay}</td>
                                            <td style={{ ...styles.gridTd, whiteSpace: 'nowrap' as const }}>{row.HowAddedDisplay}</td>
                                            <td style={styles.gridTd}>{row.ScoreCheck}</td>
                                            <td style={{ ...styles.gridTd, whiteSpace: 'nowrap' as const }}>{row.CurrentLogicUsedDisplay}</td>
                                            <td style={{ ...styles.gridTd, whiteSpace: 'nowrap' as const }}>{row.NextLogicToBeUsedDisplay == null || row.NextLogicToBeUsedDisplay === 'None' ? '' : row.NextLogicToBeUsedDisplay}</td>
                                            <td style={{ ...styles.gridTd, whiteSpace: 'nowrap' as const }}>{row.StudentComment}</td>
                                            <td style={{ ...styles.gridTd, whiteSpace: 'nowrap' as const }}>{row.ParentComment}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* Bottom Editing Section (Only visible if a row is selected) */}
            {selectedRow && (
                <div style={styles.bottomDiv}>
                    <table style={styles.bottomTable} cellPadding="8">
                        <tbody>
                            <tr>
                                <td style={{ width: '15%', textAlign: 'right', borderLeft: 'solid 1px black', borderTop: 'solid 1px black' }}>
                                    <span style={styles.bottomLabel}>Student Comment:</span>
                                </td>
                                <td style={{ width: '85%', borderRight: 'solid 1px black', borderTop: 'solid 1px black' }}>
                                    <input
                                        type="text"
                                        maxLength={500}
                                        style={styles.bottomInput}
                                        value={studentComment}
                                        onChange={(e) => setStudentComment(e.target.value)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td style={{ textAlign: 'right', borderLeft: 'solid 1px black', borderBottom: 'solid 1px black' }}>
                                    <span style={styles.bottomLabel}>Parent Comment:</span>
                                </td>
                                <td style={{ borderRight: 'solid 1px black', borderBottom: 'solid 1px black' }}>
                                    <input
                                        type="text"
                                        maxLength={500}
                                        style={styles.bottomInput}
                                        value={parentComment}
                                        onChange={(e) => setParentComment(e.target.value)}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div style={{ padding: '10px', textAlign: 'center' }}>
                        <img
                            src={saveHover ? saveImgO : saveImgN}
                            alt="Save"
                            onMouseEnter={() => setSaveHover(true)}
                            onMouseLeave={() => setSaveHover(false)}
                            onClick={handleSave}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default EL_LessonPlanMessages;